/**
 * Initalizes a new Google map
 *
 * @file Makes initialization of Google Maps possible
 * @author michael.schmid@notch-interactive.com
 *
 * @module modules/m22-map
 *
 * */


import resizeManager from '../helpers/resize-manager';

// Vars
let instance = {},
    settings,
    defaults = {
        mapModules: '[data-google-map]',
        markers: '[data-marker]',
        mapScriptSource: 'https://maps.googleapis.com/maps/api/js?key=<%key%>&callback=retrieveMapDefaults'
    },
    mapModules,
    mapDefaults,
    markers = [],
    map,

    centerMap = () => {
        if (markers.length > 1) {
            let bounds = new google.maps.LatLngBounds();

            markers.forEach((marker) => {
                bounds.extend(marker.getPosition());
            });

            map.fitBounds(bounds);
        } else {
            map.panTo(markers[0].getPosition());
        }
    },

    initMap = (mapDefaults) => {
        map = new google.maps.Map(document.getElementById(mapDefaults.mapId), {
            center: {lat: mapDefaults.lat, lng: mapDefaults.lng},
            zoom: mapDefaults.zoom,
            mapTypeId: mapDefaults.mapTypeId,
            draggable: mapDefaults.draggable,
            zoomControl: mapDefaults.zoomControl,
            scrollwheel: mapDefaults.scrollwheel,
            disableDefaultUI: mapDefaults.disableDefaultUI,
            disableDoubleClickZoom: mapDefaults.disableDoubleClickZoom
        });

        if (document.querySelector(settings.markers) !== null) {
            retrieveMarkers(map);
        }

        resizeManager.add(centerMap);
    },

    createMarker = (markerInfo, map) => {

        let marker = new google.maps.Marker({
            position: {lat: markerInfo.lat, lng: markerInfo.lng},
            map: map,
            title: markerInfo.title,
            animation: google.maps.Animation.BOUNCE
            // icon: image
        });

        setTimeout(() => {
            marker.setAnimation(null);
        }, 500);

        markers.push(marker);
    },

    retrieveMarkers = (map) => {
        let markerAttribute = document.querySelector(settings.markers).dataset.marker,
            markerInfoArray = JSON.parse(markerAttribute);

        markerInfoArray.forEach(function (markerInfo, index) {
            setTimeout(
                function () {
                    createMarker(markerInfo, map);
                }, (index + 1) * 1000);
        });
    },

    addGoogleMapsScriptToHead = () => {
        let s = document.createElement('script');
        s.setAttribute('src', settings.mapScriptSource.replace('<%key%>', DS.googleMapsApiKey));
        document.body.appendChild(s);
    };

// Will be called once the Google Map that was inserted at the end of the body script has finished loading
window.retrieveMapDefaults = () => {

    mapModules.forEach((mapModule) => {
        mapDefaults = {
            mapId: mapModule.dataset.mapId,
            lat: Number(mapModule.dataset.lat),
            lng: Number(mapModule.dataset.lng),
            zoom: Number(mapModule.dataset.zoom),
            mapTypeId: mapModule.dataset.mapTypeId
        };

        // Convert string to boolean
        mapDefaults.draggable = mapModule.dataset.draggable !== 'false';
        mapDefaults.scrollwheel = mapModule.dataset.scrollwheel !== 'false';
        mapDefaults.disableDefaultUI = mapModule.dataset.disableDefaultUi !== 'false';
        mapDefaults.zoomControl = mapModule.dataset.zoomControl !== 'false';
        mapDefaults.disableDoubleClickZoom = mapModule.dataset.disableDoubleClickZoom !== 'false';
        mapDefaults.disableDoubleClickZoom = mapModule.dataset.disableDoubleClickZoom === 'true';

        initMap(mapDefaults);
    });
};

instance.init = function (options) {

    settings = Object.assign({}, defaults, options);

    mapModules = [...document.querySelectorAll(settings.mapModules)];
    addGoogleMapsScriptToHead();
};

export default instance;
